import Products from "./products";
import AddProduct from "./add-product";
import EditProduct from "./edit-product";
import ViewProduct from "./view-product";

export default {Products, AddProduct, EditProduct, ViewProduct};